const translationKey = ({ LanguageId, ValueId }) => `${LanguageId}_${ValueId}`;

export const belongsToDeletedMapping = (deletedMappingIds) => ({ MappingId }) =>
    Boolean(MappingId) && deletedMappingIds.includes(MappingId);

// Saved rows must lose their `updated` flag, otherwise every later save resends them
// and overwrites newer values in the DB.
export const applySavedTranslations = (translationsByLanguage, savedTranslations, deletedMappingIds) => {
    const isDeleted = belongsToDeletedMapping(deletedMappingIds);
    const savedByKey = new Map(
        (savedTranslations ?? [])
            .filter(({ ValueId }) => ValueId != null)
            .map(t => [translationKey(t), t]));

    return Object.fromEntries(
        Object.entries(translationsByLanguage).map(([languageId, translations]) => [
            languageId,
            translations
                .filter(t => !isDeleted(t))
                .map(t => {
                    const saved = t.updated && savedByKey.get(translationKey(t));
                    return saved ? { ...t, Id: saved.Id, updated: false } : t;
                })
        ])
    );
};
